import axios from 'axios'
import objeler from '../components/objeler';
export const register = async (newUser) => {
    return axios
        .post('/register',{
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            email: newUser.email,
            password: newUser.password
        })
        .then(res => {
            if(res.data.success){
            }
            return res.data
        });
}
export const login = async (user) => {
    return axios
        .post('/login',{
            email: user.email,
            password: user.password
        })
        .then(res => {
            if(res.data.success){
            }
            return res.data
        })
        .catch(err => {
            console.log(err)
        });
}
export const isLoggedIn = () => {
    return  objeler.token!==undefined && objeler.token!=='';
}
export const isSignedUp = () => {
    return objeler.signup!==undefined && !objeler.signup;
}
